/* Layout */
import Layout from '../../views/layout/Layout.vue'

// const GoxipPromotionMain = () => import(/* webpackChunkName: "goxip-promotion" */ '@/views/misc/GoxipPromotion/')
// const GoxipPromotionList = () => import(/* webpackChunkName: "goxip-promotion" */ '@/views/misc/GoxipPromotion/list')
// const GoxipPromotionDetail = () => import(/* webpackChunkName: "goxip-promotion" */ '@/views/misc/GoxipPromotion/detail')

export default [
  {
    path: '/misc',
    component: Layout,
    redirect: 'noredirect',
    name: 'misc',
    alwaysShow: true,
    meta: {
      title: 'misc',
      icon: 'cog',
    },
    children: [
      {
        path: 'paylink-generator',
        component: () => import(/* webpackChunkName: "paylink-generator" */ '@/views/misc/paylink-generator.vue'),
        name: 'paylinkGenerator',
        meta: {
          title: 'paylinkGenerator',
          icon: 'link',
          accessibleName: 'paylink-generator',
        },
      },
      {
        path: 'deal-post-paylinks-generator',
        component: () => import(/* webpackChunkName: "deal-post-paylinks-generator" */ '@/views/misc/deal-post-paylinks-generator.vue'),
        name: 'paylinkGenerator',
        meta: {
          title: 'dealPostPaylinksGenerator',
          icon: 'link',
          accessibleName: 'paylink-generator',
        },
      },
      {
        path: 'other-paylinks-generator',
        component: () => import(/* webpackChunkName: "other-paylinks-generator" */ '@/views/misc/other-paylinks-generator.vue'),
        name: 'paylinkGenerator',
        meta: {
          title: 'otherPaylinksGenerator',
          icon: 'link',
          accessibleName: 'paylink-generator',
        },
      },
      {
        path: 'cpc-paylinks-generator',
        component: () => import(/* webpackChunkName: "cpc-paylinks-generator" */ '@/views/misc/cpc-paylinks-generator.vue'),
        name: 'paylinkGenerator',
        meta: {
          title: 'cpcPaylinksGenerator',
          icon: 'link',
          accessibleName: 'paylink-generator',
        },
      },
      {
        path: 'file-list',
        component: () => import(/* webpackChunkName: "file-list" */ '@/views/misc/file-list.vue'),
        name: 'FileList',
        meta: {
          title: 'fileList',
          icon: ['far', 'file-image'],
          accessibleName: 'file-list',
        },
      },
      {
        path: 'config',
        component: () => import(/* webpackChunkName: "config" */ '@/views/config'),
        name: 'config',
        meta: {
          title: 'config',
          icon: 'cog',
          accessibleName: 'config',
        },
      },
      // {
      //   path: 'goxip-promotion',
      //   component: GoxipPromotionMain,
      //   redirect: 'list',
      //   name: 'goxip-promotion',
      //   meta: {
      //     title: 'goxipPromotion',
      //   },
      //   children: [
      //     {
      //       path: 'create',
      //       component: GoxipPromotionDetail,
      //       name: 'goxip-promotion-add',
      //       meta: {
      //         title: 'create',
      //         icon: 'edit',
      //         accessibleName: 'goxip-promotion',
      //       },
      //     },
      //     {
      //       path: 'list',
      //       component: GoxipPromotionList,
      //       name: 'goxip-promotion-list',
      //       meta: {
      //         title: 'list',
      //         icon: 'list',
      //         accessibleName: 'goxip-promotion',
      //       },
      //     },
      //   ],
      // },
    ],
  },
]
